import { Alert, Button, Spinner } from 'reactstrap';

import { formatMoney } from 'src/shared/utils/money';
import { formatDuration } from '../calendarUtils';
import BookingSummary from './BookingSummary';
import ClientPicker from './ClientPicker';
import ServicePicker from './ServicePicker';
import WhenPicker from './WhenPicker';
import type { BookingForm } from './useBookingForm';

interface BookingSingleProps {
  form: BookingForm;
  titleId: string;
  onClose: () => void;
  onBook: () => void;
  timeZone?: string;
  currency?: string;
  mayOverride: boolean;
}

/**
 * Tablets and desktops: the whole booking on one screen, in the same order the
 * phone asks it. There is room to see the parts the front desk reads back to a
 * client over the phone while filling it in.
 */
export default function BookingSingle({
  form,
  titleId,
  onClose,
  onBook,
  timeZone,
  currency,
  mayOverride,
}: BookingSingleProps) {
  return (
    <>
      <div className="modal-header">
        <h2 className="modal-title" id={titleId}>
          Nueva cita
        </h2>
        <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} />
      </div>

      <div className="modal-body">
        <section className="v-booking__section">
          <h3 className="v-booking__label">Clienta</h3>
          <ClientPicker form={form} />
        </section>
        <section className="v-booking__section">
          <h3 className="v-booking__label">Servicios</h3>
          <ServicePicker form={form} currency={currency} />
        </section>
        <section className="v-booking__section">
          <h3 className="v-booking__label">Día y hora</h3>
          <WhenPicker form={form} timeZone={timeZone} mayOverride={mayOverride} />
        </section>
        <section className="v-booking__section">
          <h3 className="v-booking__label">Resumen</h3>
          <BookingSummary form={form} timeZone={timeZone} currency={currency} />
        </section>
      </div>

      <div className="modal-footer v-booking__footer">
        {form.apiMessage && (
          <Alert color="danger" role="alert" className="w-100 mb-2">
            {form.apiMessage}
          </Alert>
        )}
        <span className="v-booking__status">
          {form.canBook
            ? `${formatDuration(form.totalMinutes)} · ${formatMoney(form.totalPrice, currency)}`
            : `Falta ${form.missing.join(', ')}`}
        </span>
        <Button color="link" type="button" onClick={onClose} disabled={form.create.isPending}>
          Cancelar
        </Button>
        <Button color="primary" onClick={onBook} disabled={!form.canBook || form.create.isPending}>
          {form.create.isPending ? (
            <>
              <Spinner size="sm" /> Agendando…
            </>
          ) : (
            'Agendar'
          )}
        </Button>
      </div>
    </>
  );
}
